import {MainVideoState} from "../definitions/MainVideoState";
import {updateButtonsFromState} from "../state-change-side-effects/UpdateButtonsFromState";

export const videoPlaybackHasStarted = (state: MainVideoState) => {
    state.videoIsPlaying = true;
    updateButtonsFromState(state);
};
